import BaseDataObject from './BaseDataObject';

export default class Money extends BaseDataObject {
  getSum() {
    return this.getFloat('sum');
  }
  setSum(v) {
    return this.setFloat('sum', v);
  }

  getCurrency() {
    return this.getString('currency');
  }
  setCurrency(v) {
    return this.setString('currency', v);
  }
}
